import {AGENCY_JOB_TITLE} from './../actions/ActionTypes';
import InitialState from './InitialState';

const JobTitleReducer = (state = InitialState.jobTitle, action) => {
    switch (action.type) {
        case AGENCY_JOB_TITLE: {
            return action.agencyJobTitle;
        }

        default:
            return state;
    }
};
export default JobTitleReducer;



// WEBPACK FOOTER //
// ./src/reducers/JobTitleReducer.js